import { DateTime } from "luxon";
import React, { useState } from "react";
import useStore from "../../../../context/useStore";
import { Pill } from "../../../common/DataList";
import ChooseSiteReport from "./ChooseSiteReport";
import RdvItemContainer from "./RdvItemContainer";
import RdvLocation from "./RdvLocation";
import RecipientRdvResult from "./RecipientRdvResult";
import ReportRdv from "./ReportRdv";
import SynchroFTStatus from "../SynchroFTStatus";
import ForceSynchroFTButton from "../ForceSynchroFTButton";

const RecipientRdvListItem = ({
  rdv,
  rdvIndex,
  getReportDates,
  errors,
  rdvSlots,
  setOriginSelected,
  originSelected,
  reasonSelected,
  saveReportRdv,
  isSaved,
  isSaving,
  rdvSelected,
  rdspId,
  reportRdvOpen,
  isLoadingSlots,
  setReasonSelected,
  setRdvSelected,
  isReportSiteOpen,
  setIsReportSiteOpen,
  deleteRdv,
  deletingRdvslotCalendarId,
  getRdvs,
}) => {
  const [state] = useStore();
  const constants = state.constants.items;
  const isRdvDateManual = rdv.slotCalendar.type == 3;
  const [selectedSiteId, setSelectedSiteId] = useState("");

  const fetchReportDates = (rdv, siteId) => {
    getReportDates(rdv, siteId);
    setSelectedSiteId(siteId);
  };
  const canDeleteRdv = state.auth?.user?.email?.endsWith("@10positif.com");
  const subTypeName =
    rdv.slotCalendar.subType &&
    constants.SLOT_SUBTYPES.find((st) => st.id == rdv.slotCalendar.subType)?.name;
  const isDeleting = deletingRdvslotCalendarId === rdv.slotCalendarId;

  return (
    <RdvItemContainer
      header={
        <>
          <div className="rdv-card__when">
            <h4 className="rdv-card__date">
              {DateTime.fromISO(rdv.date).toFormat("dd LLLL yyyy à HH:mm", { locale: "fr" })}
            </h4>
            <div className="rdv-card__pills">
              {subTypeName && <Pill tone="neutral">{subTypeName}</Pill>}
              {rdv.slotCalendar.isPhoneCall && (
                <Pill tone="dark" icon="fa-phone">
                  Téléphonique
                </Pill>
              )}
              {rdv.result && (
                <Pill tone="ok" icon="fa-check">
                  Terminé
                </Pill>
              )}
            </div>
          </div>
          <div className="rdv-card__actions">
            <SynchroFTStatus categorie="RDV" entiteId={rdv.id} />
            {rdvIndex == 0 && (
              <div data-priv="report_recipient_appointments">
                <button
                  type="button"
                  className={`btn btn-sm ${rdv.result ? "btn-ghost" : "btn-primary"}`}
                  onClick={() => setIsReportSiteOpen(isReportSiteOpen ? null : rdv.id)}
                >
                  Reporter
                </button>
              </div>
            )}
            {canDeleteRdv && (
              <button
                type="button"
                className="btn btn-sm btn-outline-danger"
                onClick={() => deleteRdv(rdv.slotCalendarId)}
                disabled={isDeleting}
              >
                {isDeleting ? (
                  <>
                    <i className="fa fa-spinner fa-spin mr-1" aria-hidden="true" />
                    Suppression...
                  </>
                ) : (
                  <>
                    <i className="fa fa-trash mr-1" aria-hidden="true" />
                    Supprimer
                  </>
                )}
              </button>
            )}
          </div>
        </>
      }
    >
      <div className="rdv-card__body">
        <RdvLocation rdv={rdv} />

        {isReportSiteOpen == rdv.id && (
          <div className="rdv-card__panel">
            <ChooseSiteReport
              getReportDates={(siteId) => fetchReportDates(rdv, siteId)}
              siteId={rdv.site.id}
              rdspId={rdspId}
            />
          </div>
        )}
        {reportRdvOpen == rdv.id && selectedSiteId ? (
          <div className="rdv-card__panel">
            <ReportRdv
              isLoadingSlots={isLoadingSlots}
              errors={errors}
              rdvSlots={rdvSlots}
              setOriginSelected={setOriginSelected}
              setReasonSelected={setReasonSelected}
              constants={constants}
              setRdvSelected={setRdvSelected}
              originSelected={originSelected}
              reasonSelected={reasonSelected}
              saveReportRdv={saveReportRdv}
              isSaved={isSaved}
              isSaving={isSaving}
              rdvSelected={rdvSelected}
              isRdvDateManual={isRdvDateManual}
              selectedSiteId={selectedSiteId}
            />
          </div>
        ) : null}

        {rdv.result && <RecipientRdvResult rdv={rdv} />}
      </div>
      <div className="rdv-card__footer">
        <ForceSynchroFTButton
          categorie="RDV"
          entiteId={rdv.id}
          label="Resynchroniser ce RDV"
          onSuccess={getRdvs}
        />
      </div>
    </RdvItemContainer>
  );
};

export default RecipientRdvListItem;
